import * as React from 'react';
import { CustomSubmitButton } from "soprasteria-ui-library";
import { ReferralAdminApi } from "../../../../api/ReferralAdminApi";
import { useAuth } from '../../../../App';

interface IReferralResetAnswerButton {
    canResetReferral: boolean;
    referralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
}

export const ReferralResetAnswerButton: React.FunctionComponent<IReferralResetAnswerButton> = ({ canResetReferral, referralId, changeErrorMessage, changeSuccessMessage, getReferral }) => {

    const auth = useAuth();
    const api = new ReferralAdminApi(auth);
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    const resetReferralAnswer = () => {
        setIsSubmitting(true);
        api.resetReferralAnswer(referralId.toString(), () => {
            changeSuccessMessage("Remissvaret har återställts");
            getReferral(referralId);
        }, (error) => {
            changeErrorMessage(error);
        }, () => setIsSubmitting(false));
    }

    return (
        <>
            {
                canResetReferral ?
                    <CustomSubmitButton isLoading={isSubmitting} onButtonSubmit={resetReferralAnswer}>Återställ remissvar</CustomSubmitButton>
                    : null
            }
        </>
    )
}